module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_70.643d54a8.jpg";